import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import TableActions from '../../../../components/TableActions';
import { Helpers } from '../../../../helpers/Helpers';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetAntrepoInListPagingAndFilterRequest } from '../../../../models/request/antrepoIn/GetAntrepoInListPagingAndFilterRequest';
import { GetAntrepoInListPagingAndFilterResponseItem } from '../../../../models/response/antrepoIn/GetAntrepoInListPagingAndFilterResponse';
import { GetCompanyListResponseItem } from '../../../../models/response/company/GetCompanyListResponse';
import { RootState } from '../../../../redux/store';
import { ConstantService } from '../../../../services/ConstantService';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import toast from "react-hot-toast";
import { DocumentService } from '../../../../services/DocumentService';
import { GetDocumentListResponse, GetDocumentListResponseData } from '../../../../models/response/document/GetDocumentListResponse';
import { useDispatch } from 'react-redux';
import { storeActivityIndicator } from '../../../../redux/reducers/authSlice';
import axios from 'axios';
import { AntrepoInService } from '../../../../services/AntrepoInService';
import { DownloadReportResponse } from '../../../../models/response/document/DownloadReportResponse';
import { GetConstantListResponse } from '../../../../models/response/constant/GetConstantListResponse';
import Documents from '../../../../components/Documents';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetAntrepoInListPagingAndFilterRequest
    getData: (_filter?: GetAntrepoInListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetAntrepoInListPagingAndFilterRequest>>
    items: GetAntrepoInListPagingAndFilterResponseItem[]
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const AntrepoInListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    items,
    selectedCount,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)
    const dispatch = useDispatch();
    const [antrepoExitTypes, setAntrepoExitTypes] = useState<CustomSingleSelectModel[]>([]);

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getCustomData();
    }, [])

    const getCustomData = async () => {
        try {
            var response2: GetConstantListResponse = await ConstantService.getConstantList('ANTREPO_EXIT_TYPE');

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setAntrepoExitTypes(response2.data.map(function (x) {
                return {
                    label: x.value,
                    value: x.constantId
                }
            }))
        } catch (error: any) {
            toast.error(error)
        }
        finally {
        }
    }

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            {
                auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canDocument && (
                    <Documents
                        items={items.map(function (x) {
                            return { entityId: x.antrepoInId, isSelected: x.isSelected }
                        })}
                        pageName={pageName}
                    />
                )
            }

            <TableActions
                list={[
                    ...antrepoExitTypes.map(function (x) {
                        return {
                            isDisabled: !(
                                items.filter(x => x.isSelected).length == 1 &&
                                items.filter(x => x.isSelected && x.isRedrese).length == 0 &&
                                (!Helpers.isEmpty(items.filter(x => x.isSelected)[0].transferAntrepoOutId) || items.filter(x => x.isSelected)[0].antrepoInVehicles.filter(x => Helpers.isEmpty(x.vehicleId)).length == 0) &&
                                items.filter(x => x.isSelected)[0].antrepoInVehicles.filter(x => Helpers.isEmpty(x.antrepoEnteranceDate)).length == 0
                            ),
                            text: x.label,
                            subItems: [
                                {
                                    text: 'Düşümlü Çıkış',
                                    onClick: () => navigate((`/antrepoout/listadd?antrepoInId=${items.filter(x => x.isSelected)[0].antrepoInId}&isPartial=1&exitTypeId=${x.value}`))
                                },
                                {
                                    text: 'Komple Çıkış',
                                    onClick: () => navigate((`/antrepoout/listadd?antrepoInId=${items.filter(x => x.isSelected)[0].antrepoInId}&isPartial=0&exitTypeId=${x.value}`))
                                }
                            ]
                        }
                    }),
                    ...[{
                        isDisabled: !(
                            items.filter(x => x.isSelected).length == 1 &&
                            items.filter(x => x.isSelected && x.isRedrese).length == 0 &&
                            (!Helpers.isEmpty(items.filter(x => x.isSelected)[0].transferAntrepoOutId) || items.filter(x => x.isSelected)[0].antrepoInVehicles.filter(x => Helpers.isEmpty(x.vehicleId)).length == 0) &&
                            items.filter(x => x.isSelected)[0].antrepoInVehicles.filter(x => Helpers.isEmpty(x.antrepoEnteranceDate)).length == 0
                        ),
                        text: 'Redrese İşlemi',
                        onClick: () => navigate((`/antrepoin/listadd?id=${items.filter(x => x.isSelected)[0].antrepoInId}&isRedrese=1`))
                    }],
                ]}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli ve arama kutusu kaldırıldı (22.09.2026): Antrepo Giriş Tarihi, Alıcı /
                Gönderici / Gümrük Firması, Gümrük Müdürlüğü, Araç / Dorse Plaka, Tedarikçi, Çıkış Ülkesi ve
                Beyanname Durumu (açılışta "Açık Beyanname") kolon başlığının altındaki filtrede. Aramanın
                baktığı Konteyner / Taşıma Belge / Kamyon Rapor / Özet Beyan No ve Serbest Depo Ref No gizli
                kolon olarak kolon seçicide. */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/antrepoin/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Giriş Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default AntrepoInListFilters;